import axiosInstance from "./axiosInstance";
import { showAlertError } from '../utils/alertHelper';

const basePath = "/pagosdetalle";

export const listPagosDetalle = async () => {
    try {
        const response = await axiosInstance.get(`${basePath}/list`);
        return response.data;
    } catch (error) {
        console.error("Error en obtener detalle de pagos:", error);
        showAlertError("Error inesperado", "Ocurrió un problema al obtener el detalle de los pagos.");
        throw error;
    }
};
